/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
import store from '@/common/store/';
import Cookies from "js-cookie";
import { setAgentCode } from '@/common/utils/initRegisterAgentCode.js'
import { scrollToTop } from '@/common/utils/index.js'

const files = require.context('./module/', true, /\.js$/)
const modules = []
files.keys().forEach(key => {
    if (files(key).default) {
        if (files(key).default.constructor === Object) modules.push(files(key).default)
        if (files(key).default.constructor === Array) modules.push(...files(key).default)
    }
})
Vue.use(Router);

const _import = name => {
    return resolve => require([`../views/${name}`], resolve)
}

// export default
const router = new Router({
    mode: 'history',
    base: '/',
    routes: [{
        path: '',
        //component: () => import('../views/main'),
        component: () => import(/* webpackChunkName: "main" */ '../views/main'),
        children: [
            {
                path: '/home',
                redirect: '/'
            },
            {
                path: '/',
                meta: {
                    navShow: true,
                    // isRefreshAccount: true,
                    diffBg: true,
                    isContact: true, // 底部联系方式
                    gameNav: true,
                    keepAlive: true
                },
                name: 'home',
                component: () => import(/* webpackChunkName: "home" */ '../views/home/index.vue'),
                // component: () => import('../views/home/index.vue'),
                children: [
                    {
                        path: '/',
                        meta: {
                            navShow: true,
                            // isRefreshAccount: true,
                            diffBg: true,
                            isContact: true, // 底部联系方式
                            gameNav: true,
                            keepAlive: true
                        },
                        name: 'home',
                        component: () => import(/* webpackChunkName: "home" */ '../views/home/pages-0.vue'),
                        // component: () => import('../views/home/pages-8.vue')
                    },
                    {
                        path: '/hot',
                        meta: {
                            navShow: true,
                            // isRefreshAccount: true,
                            diffBg: true,
                            isContact: true, // 底部联系方式
                            gameNav: true,
                            keepAlive: true
                        },
                        name: 'home',
                        component: () => import(/* webpackChunkName: "home" */ '../views/home/pages-0.vue'),
                    },
                    {
                        path: '/gamelobby/sports',
                        meta: {
                            navShow: true,
                            // isRefreshAccount: true,
                            diffBg: true,
                            isContact: true, // 底部联系方式
                            gameNav: true,
                            keepAlive: true
                        },
                        name: 'sports',
                        component: () => import(/* webpackChunkName: "home" */ '../views/home/pages-3.vue'),
                    },
                    {
                        path: '/gamelobby/live',
                        meta: {
                            navShow: true,
                            // isRefreshAccount: true,
                            diffBg: true,
                            isContact: true, // 底部联系方式
                            gameNav: true,
                            keepAlive: true
                        },
                        name: 'live',
                        component: () => import(/* webpackChunkName: "home" */ '../views/home/pages-2.vue'),
                    },
                    {
                        path: '/gamelobby/egame',
                        meta: {
                            navShow: true,
                            // isRefreshAccount: true,
                            diffBg: true,
                            isContact: true, // 底部联系方式
                            gameNav: true,
                            keepAlive: true
                        },
                        name: 'Slot',
                        component: () => import(/* webpackChunkName: "home" */ '../views/home/pages-1.vue'),
                    },
                    {
                        path: '/gamelobby/chess',
                        meta: {
                            navShow: true,
                            // isRefreshAccount: true,
                            diffBg: true,
                            isContact: true, // 底部联系方式
                            gameNav: true,
                            keepAlive: true
                        },
                        name: 'chess',
                        component: () => import(/* webpackChunkName: "home" */ '../views/home/pages-6.vue'),
                    },
                    {
                        path: '/gamelobby/fish',
                        meta: {
                            navShow: true,
                            // isRefreshAccount: true,
                            diffBg: true,
                            isContact: true, // 底部联系方式
                            gameNav: true,
                            keepAlive: true
                        },
                        name: 'fish',
                        component: () => import(/* webpackChunkName: "home" */ '../views/home/pages-5.vue'),
                    },
                    {
                        path: '/gamelobby/lottery',
                        meta: {
                            navShow: true,
                            // isRefreshAccount: true,
                            diffBg: true,
                            isContact: true, // 底部联系方式
                            gameNav: true,
                            keepAlive: true
                        },
                        name: 'lottery',
                        component: () => import(/* webpackChunkName: "home" */ '../views/home/pages-4.vue'),
                    },
                    {
                        path: '/gamelobby/Classic',
                        meta: {
                            navShow: true,
                            // isRefreshAccount: true,
                            diffBg: true,
                            isContact: true, // 底部联系方式
                            gameNav: true,
                            keepAlive: true
                        },
                        name: 'Classic',
                        component: () => import(/* webpackChunkName: "home" */ '../views/home/pages-7.vue'),
                    },
                    {
                        path: '/gamelobby/bingo',
                        meta: {
                            navShow: true,
                            // isRefreshAccount: true,
                            diffBg: true,
                            isContact: true, // 底部联系方式
                            gameNav: true,
                            keepAlive: true
                        },
                        name: 'bingo',
                        component: () => import(/* webpackChunkName: "home" */ '../views/home/pages-8.vue'),
                    },
                    // {
                    //     path: '/game/iframe',
                    //     meta: {
                    //         navShow: false,
                    //         // isRefreshAccount: true,
                    //         diffBg: false,
                    //         isContact: false, // 底部联系方式
                    //         gameNav: false,
                    //         keepAlive: true
                    //     },
                    //     name: 'iframe',
                    //     component: () => import('../views/game/iframe.vue')
                    // }
                ]
            },
            {
                path: '/game/iframe',
                meta: {
                    navShow: false,
                    // isRefreshAccount: true,
                    diffBg: false,
                    isContact: false, // 底部联系方式
                    gameNav: false,
                    keepAlive: true
                },
                name: 'iframe',
                component: () => import('../views/game/iframe.vue')
            },
            {
                path: '/affiliate',
                name: 'Affiliate',
                meta: {
                    navShow: true,
                    titleHide: false,
                    isContact: true, // 底部联系方式
                    diffBg: true,
                    title: '代理介绍',
                },
                // component: () => import('../views/My/affiliate')
                component: _import('My/affiliate')
                
            },
            // {
            //   path: '/game/:id',
            //   meta: {
            //     navShow: true,
            //     gameNav: true,
            //     diffBg: true,
            //   },
            //   name: 'Game',
            //   component: _import('game')
            // },
            {
                path: '/menu',
                meta: {
                    navShow: true,
                    diffBg: true,
                    isContact: true, // 底部联系方式
                    titleHide: false,
                },
                name: 'menu',
                component: () => import('../views/menu')
            },
            {
                path: '/search',
                meta: {
                    navShow: false,
                    diffBg: true,
                    isContact: true, // 底部联系方式
                    titleHide: true,
                },
                name: 'search',
                component: () => import('../views/search')
            },
            // 优惠
            {
                path: '/promotions',
                meta: {
                    navShow: true,
                    diffBg: true,
                    isContact: true, // 底部联系方式
                    titleHide: true,
                },
                name: 'promotions-page',
                component: () => import('../views/discounts')
            },
            // 取款记录
            {
                path: '/withdraw/audit',
                name: 'withdrawAudit',
                meta: { navShow: true, isContact: true, titleHide: true,requireAuth:true,title: '取款记录'},
                component: () => import('../views/withdraw/audit.vue')
            },
            {
                path: '/withdraw/main',
                name: 'withdrawMain',
                meta: { navShow: false, titleHide: true,requireAuth:false,title: 'main'},
                component: () => import('../views/withdraw/main.vue')
            },
            {
                path: '/withdraw/rupee',
                name: 'withdrawMain',
                meta: { navShow: false, titleHide: true,requireAuth:false,title: 'rupee'},
                component: () => import('../views/withdraw/rupee.vue')
            },
            {
                path: '/withdraw/summary',
                name: 'withdrawSummary',
                meta: { navShow: false, titleHide: true,requireAuth:false,title: 'summary'},
                // component: () => import('../views/withdraw/summary.vue')
                component: _import('withdraw/summary.vue')
            },
            { //预约取款
                path: '/withdraw/bookWithdraw',
                meta: { navShow: false, titleHide: true,requireAuth:false,title: 'bookWithdraw' },
                 name: 'bookWithdraw',
                 component: () => import('../views/withdraw/bookWithdraw.vue')
            },
            //usdt取款
            {
                path: '/withdraw/crypto',
                meta: { navShow: false, titleHide: true,requireAuth:false,title: 'Crypto Withdraw' },
                name: 'crypto',
                component: () => import('../views/withdraw/crypto.vue')
            },
            {
                path: '/account/bankcards/list',
                name: 'withdrawBankList',
                meta: { navShow: false, titleHide: true,requireAuth:false,title: '银行卡列表'},
                component: () => import('../views/withdraw/banklist.vue')
            },
            {
                path: '/account/bankcards/usdtlist',
                name: 'withdrawBankUsdtlist',
                meta: { navShow: false, titleHide: true,requireAuth:false,title: 'USDT列表'},
                component: () => import('../views/withdraw/usdtlist.vue')
            },
            {
                path: '/account/bankcards/rupeelinklist',
                name: 'withdrawBankUsdtlist',
                meta: { navShow: false, titleHide: true,requireAuth:false,title: 'rupeelink列表'},
                component: () => import('../views/withdraw/rupeelinklist.vue')
            },
            {
                path: '/betSlip',
                meta: {
                    navShow: false,
                    titleHide: true,
                    // isService: true
                },
                name: 'betSlip',
                component: () => import('../views/betSlip')
            },              
            {
                path: '/discounts/discountsDetail',
                meta: {
                    navShow: false,
                    titleHide: true,
                    // isService: true
                },
                name: 'discountsDetail',
                component: () => import('../views/discounts/discountsDetail')
            },
            {
                path: '/agent/apply',
                meta: {
                    navShow: false,
                    diffBg: true,
                    titleHide: true
                },
                name: 'register',
                component: () => import('../views/register/agentApply.vue')
            },
            {
                path: '/signup',
                meta: {
                    navShow: false,
                    diffBg: true,
                    titleHide: true
                },
                name: 'register',
                // component: () => import('../views/register/')
                component: () => import('../views/register/index2.vue')
            },
            {
                path: '/login',
                meta: {
                    navShow: false,
                    diffBg: true,
                    titleHide: true
                },
                name: 'login',
                component: () => import('../views/login/index2.vue')
            },

            // {
            //     path: '/login2',
            //     meta: {
            //         navShow: false,
            //         diffBg: true,
            //         titleHide: true
            //     },
            //     name: 'login',
            //     component: () => import('../views/login/index2.vue')
            // },
            // 找回密码
            {
                path: '/forgetPassword',
                meta: {
                    navShow: false,
                    titleHide: true
                },
                name: 'forgetPassword',
                component: () => import('../views/forgetPassword/forgetPassword')
            },
            {
                path: '/findPassword',
                meta: {
                    navShow: false,
                    titleHide: true
                },
                name: 'findPassword',
                component: () => import('../views/forgetPassword/findPassword')
            },
            //签到
            {
                path: '/sign',
                meta: {
                    navShow: false,
                    titleHide: true,
                    requireAuth: true
                },
                name: 'sign',
                component: () => import('../views/sign/sign')
            }, //签到主页
            {
                path: '/integral',
                meta: {
                    navShow: false,
                    titleHide: true,
                    requireAuth: true
                },
                name: 'integral',
                component: () => import('../views/sign/integral')
            }, //积分记录
            {
                path: '/exchange',
                meta: {
                    navShow: false,
                    titleHide: true,
                    requireAuth: true
                },
                name: 'exchange',
                component: () => import('../views/sign/exchange')
            }, //兑换记录
            {
                path: '/rule',
                meta: {
                    navShow: false,
                    titleHide: true,
                    requireAuth: true
                },
                name: 'rule',
                component: () => import('../views/sign/rule')
            }, //规则

            //转盘主页app跳转
            {
                path: '/wheel',
                meta: {
                    navShow: false,
                    titleHide: true,
                },
                name: 'wheel',
                component: () => import('../views/wheel')
            },
            {
                path: '/inbox',
                name: 'inbox',
                meta: { navShow: false, titleHide: true,requireAuth:true,title: '站内信详情'},
                // component: () => import('../views/My/StationLetter')
                component: _import('My/StationLetter')
            },
            {
                path: '/finan-history/promotion',
                name: 'promotionHistory',
                meta: { navShow: false, titleHide: true,requireAuth:true,title: 'promotion'},
                // component: () => import('../views/My/MerchRecord/promotion.vue')
                component: _import('My/MerchRecord/promotion.vue')
            },
            {
                path: '/finan-history/rebate',
                name: 'rebateHistory',
                meta: { navShow: false, titleHide: true,requireAuth:true,title: 'rebate'},
                // component: () => import('../views/My/MerchRecord/rebate.vue')
                component: _import('My/MerchRecord/rebate.vue')
            },
            {
                path: '/finan-history/vip',
                name: 'vipHistory',
                meta: { navShow: false, titleHide: true,requireAuth:true,title: 'vip'},
                // component: () => import('../views/My/MerchRecord/vip.vue')
                component: _import('My/MerchRecord/vip.vue')
            },
            {
                path: '/finan-history/affiliate',
                name: 'affiliateHistory',
                meta: { navShow: false, titleHide: true,requireAuth:true,title: 'affiliate'},
                // component: () => import('../views/My/MerchRecord/affiliate.vue')
                component: _import('My/MerchRecord/affiliate.vue')
            },
            {
                path: '/finan-history/activity',
                name: 'activityHistory',
                meta: { navShow: false, titleHide: true,requireAuth:true,title: 'activity'},
                // component: () => import('../views/My/MerchRecord/activity.vue')
                component: _import('My/MerchRecord/activity.vue')
            },
            {
                path: '/finan-history/Turnover',
                name: 'TurnoverHistory',
                meta: { navShow: false, titleHide: true,requireAuth:true,title: 'Turnover'},
                // component: () => import('../views/My/MerchRecord/Turnover.vue')
                component: _import('My/MerchRecord/Turnover.vue')
            },
            {
                path: '/finan-history/withdrawal',
                name: 'withdrawalHistory',
                meta: { navShow: false, titleHide: true,requireAuth:true,title: 'withdrawal'},
                // component: () => import('../views/withdraw/history.vue')
                component: _import('withdraw/history.vue')
            },
            {
                path: '/finan-history/deposit',
                name: 'depositHistory',
                meta: { navShow: false, titleHide: true,requireAuth:true,title: '存款记录'},
                // component: () => import('../views/My/MerchRecord/deposit.vue')
                component: _import('My/MerchRecord/deposit.vue')
            },
            {
                path: '/playerInfo',
                name: 'playerInfo',
                meta: { navShow: false, titleHide: true,requireAuth:true,title: '取款密码'},
                // component: () => import('../views/My/AccountManat/newWithdrawPasword.vue')
                component: _import('My/AccountManat/newWithdrawPasword.vue')
            },
            
            {path: '/vip',meta: { navShow: false, isContact: true, titleHide: true}, redirect:'/vip/index' , name: 'vip', component: _import('vip') ,
                children: [
                    {path: 'index',meta: { navShow: false, isContact: true, titleHide: true }, name: '/vip/index', component: _import('vip/info') }, 
                    {path: 'details',meta: { navShow: false, isContact: true, titleHide: true }, name: '/vip/details', component: _import('vip/details') }, 
                ]
            },

            {path: '/agency',meta: { navShow: false, isContact: true, titleHide: true, noBottom: true }, redirect:'/agency/index' , name: 'agency', component: _import('agency') ,
                children: [
                    {path: 'index',meta: { navShow: false, isContact: true, titleHide: true, noBottom: true }, name: '/agency/index', component: _import('agency/agency') },
                    {path: 'team',meta: { navShow: false, isContact: true, titleHide: true, noBottom: true }, name: '/agency/team', component: _import('agency/team') },
                    {path: 'management',meta: { navShow: false, isContact: true, titleHide: true, noBottom: true }, name: '/agency/management', component: _import('agency/management') },
                    {path: 'commission',meta: { navShow: false, isContact: true, titleHide: true, noBottom: true }, name: '/agency/commission', component: _import('agency/Commission') },
                    {path: 'withdraw',meta: { navShow: false, isContact: true, titleHide: true, noBottom: true }, name: '/agency/withdraw', component: _import('agency/Withdraw') },
                    {path: 'apply',meta: { navShow: false, isContact: true, titleHide: true, noBottom: true }, name: '/agency/apply', component: _import('agency/apply') },
                ]
            },

            // 新加路由
            ...modules
        ]
    },
    {
        path: '/red-envelope',
        name: 'redEnvelope',
        meta: {
          navShow: true,
          titleHide: false,
        //   isContact: false, // 底部联系方式
        //   diffBg: true,
        //   title: '红包雨' ,
        },
        // component: () => import('../views/red/index.vue')
        component: _import('red/index.vue')
    },
    {
        path: '/gift',
        name: 'gift',
        meta: {
          navShow: true,
          titleHide: false,
        },
        // component: () => import('../views/red/index.vue')
        component: _import('red/index.vue')
    },
    {
        path: '/promo-history',
        name: 'promoHistory',
        meta: { navShow: false, titleHide: true,requireAuth:true,title: '优惠记录'},
        // component: () => import('../views/My/promo-history')
        component: _import('My/promo-history')
        
    },
    
    {
        path: '/inbox/personalMsg',
        name: 'personalMsg',
        meta: { navShow: false, titleHide: true,requireAuth:true,title: '站内信详情'},
        // component: () => import('../views/My/StationLetter/personalMsg.vue')
        component: _import('My/StationLetter/personalMsg.vue')
    },
    {
        path: '/ekgame',
        name: 'ekgame',
        meta: { navShow: false, titleHide: true, isServiceHide: true, requireAuth:false, title: '下载页'},
        component: () => import('../views/download/index.vue')
    },
    {
        path: '/news',
        name: 'news',
        meta: { navShow: false, titleHide: true, requireAuth:false, title: 'news'},
        // component: () => import('../views/My/StationLetter/news.vue')
        component: _import('My/StationLetter/news.vue')
    },
    {
        path: '/providers',
        name: 'providers',
        meta: { navShow: false, titleHide: false, requireAuth:false, title: 'providers'},
        component: () => import('../views/providers/index.vue')
    },
    {
        path: '/forgetusername',
        meta: {
            navShow: false,
            diffBg: true,
            titleHide: true
        },
        name: 'forgetusername',
        component: () => import('../views/login/forgetusername.vue')
    },


    // 404
    {
        path: '/404',
        meta: {
            navShow: false,
            titleHide: true
        },
        name: 'notfound',
        component: () => import('@/common/notfound/404')
    },
    {
        path: '*',
        meta: {
            navShow: false,
            titleHide: true
        },
        redirect: '/404'
    }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {
                x: 0,
                y: 0
            }
        }

    }
});

router.beforeEach(function (to, from, next) {
     // 获取到前面打过标签的元素，将其scrollTop属性设置为0
    document.documentElement.scrollTop = 0
    // 滚动条可能出现在HTML元素上而不是body上，确保兼容性，同时将HTML和body中scrollTop属性设置为0
    document.body.scrollTop = 0
    if(to.fullPath === '/register'  || to.fullPath === '/signup'){
        actionLogEvent("af_registerClick")  //上报点击注册
    }
    setAgentCode(store) // Cookies
    // if (to.query.isApp) {
    //     store.commit('setIsApp', true)
    // } else {
    //     store.commit('setIsApp', false)
    // }
    if (to.query.isDownloadApp) {
        //有值存值 缓存时间为1天（24小时）
        localStorage.setItem('isAppOpen',to.query.isDownloadApp);
    }
    //获取到的只能是string  如果为'true' 表示为App打开
    if (localStorage.getItem('isAppOpen') === 'true') {
        store.commit('setIsApp',true)
    }else if(localStorage.getItem('isAppOpen') === 'false'){
        store.commit('setIsApp',false)
    }
    // store.commit('updateLoadingStatus', { isLoading: true })
    if (to.matched.some(r => r.meta.requireAuth)) {
        if (Cookies.get("UUID") || window.localStorage.getItem('UUID')) {
            next();
        } else {
            if (to.query.UUID) {
                Cookies.set("UUID", to.query.UUID)
                next()
            } else {
                // const pathArr = ['/home', '/promotions', '/Service', '/My'] // 未登录无需跳转的路由
                // if (!pathArr.includes(from.path)) next({ path: '/' })
                store.commit('updateLoadingStatus', { isLoading: false })
                if (from.path === '/signup' || from.path === '/login') { // 如果未登录从注册登录页面返回 则必须登录的页面重定向直接进入首页
                    next('/')
                } else {
                    next('/login?backPath=' + from.fullPath + '&successPath=' + to.fullPath)
                }
            }
        }
    } else {
        if ((from.path !== '/signup' && to.fullPath === '/login') || (from.path !== '/login' && to.fullPath === '/signup')) {
            next(to.path + '?backPath=' + from.fullPath + '&successPath=' + from.fullPath)
        } else {
            next()
        }
    }
})

var routerTime2 = null
router.afterEach((to) => {
    scrollToTop() // 跳转后滚动到顶部
    clearTimeout(routerTime2)
    let onloadTime = setInterval(() => {
        // document.getElementById('appRouter').style.display = 'none'
        // document.readyState判断当前节点加载状态
        // loading开始加载 interactive文件已经装载完毕，可以访问dom complete页面加载完成
        if (document.readyState === 'interactive' || document.readyState === 'complete') {
            store.commit('updateLoadingStatus', { isLoading: false });
            clearTimeout(onloadTime);
        }
    }, 400);

    routerTime2 = setTimeout(() => {
        store.commit('updateLoadingStatus', { isLoading: false })
        if (to.meta.isRefreshAccount) store.dispatch('refreshAccount', { isHand: false, type: 2 }) // 是否提取并更新余额
        clearTimeout(routerTime2)
        clearTimeout(onloadTime);
    }, 3000)

    const UCCHAT_BOX = document.getElementById('UCCHAT_BOX');

    if (UCCHAT_BOX) {
        if (to.path === '/game/iframe') {
            UCCHAT_BOX.setAttribute('class', 'disNone');
        } else {
            UCCHAT_BOX.setAttribute('class', '');
        }
    }

    if (window.LiveChatWidget) {
        // window.LiveChatWidget.call('minimize')
        if (to.meta.isContact) window.LiveChatWidget.call('minimize')
        if (!to.meta.isContact) window.LiveChatWidget.call('hide')
        if (!to.meta.isServiceHide){
            window.LiveChatWidget.call('minimize')
        } else {
            window.LiveChatWidget.call('hide')
        }
        
    }
    // livechat.reset(to.path)
});

var LS = window.localStorage
LS.removeItem('LiveChatWidgetCount')
var livechat = {
    path: ['/My', '/home'],
    // path: [],
    timer: null,
    reset: function (links) { // 显示隐藏livechat
        clearTimeout(this.timer)
        if (!window.LiveChatWidget) {
            const count = LS.getItem('LiveChatWidgetCount') * 1
            if (count < 2) {
                LS.setItem('LiveChatWidgetCount', count + 1)
                this.reset(links)
            }
        } else {
            LS.removeItem('LiveChatWidgetCount')
            if (this.path.includes(links)) {
                window.LiveChatWidget.call('minimize')
            } else {
                window.LiveChatWidget.call('hide')
                this.timer = setTimeout(() => {
                    window.LiveChatWidget.call('hide')
                    clearTimeout(this.timer)
                }, 2500)
            }
        }
    }
}

export default router;



// WEBPACK FOOTER //
// ./src/pages/build922/router/index.js